import React, { Component } from 'react';
import Search from '../components/search/search';
import Adapter from '../components/search/adapter';
import * as grpcWeb from 'grpc-web';
import Header from '../components/header';
import Footer from '../components/footer';
import { AdminServiceClient } from '../rpc/admin/AdminServiceClientPb';
import { SearchRequest, SearchResponse, AutocompleteRequest, AutocompleteResponse } from '../rpc/admin/search_pb';
import { getAuthMetadata } from '../helpers/rpc';
import Helmet from 'react-helmet';
import { PaddedContainer } from '../components/base';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getUser } from '../helpers/user';

class ZandersProps { }

class ZandersState { }

class ZandersAdapter extends Adapter {

    protected performSearch(client: AdminServiceClient, request: SearchRequest): Promise<SearchResponse> {
        return new Promise((resolve, reject) => {
            client.zandersSearch(request, getAuthMetadata(), (err: grpcWeb.Error, response: SearchResponse) => {
                if (!err) {
                    resolve(response);
                } else {
                    reject(err);
                }
            });
        });
    }

    performAutocomplete(client: AdminServiceClient, request: AutocompleteRequest): Promise<AutocompleteResponse> {
        return new Promise((resolve, reject) => {
            client.zandersAutocomplete(request, getAuthMetadata(), (err: grpcWeb.Error, response: AutocompleteResponse) => {
                if (!err) {
                    resolve(response);
                } else {
                    reject(err);
                }
            });
        });
    }
}

class Zanders extends Component<ZandersProps & RouteComponentProps<any>, ZandersState> {

    private adapter: Adapter

    constructor(props: ZandersProps & RouteComponentProps<any>) {
      super(props);
      this.adapter = new ZandersAdapter(props.history);
    }

    render() {
        if (!getUser()) {
            return <div>Redirecting...</div>;
        }
        return (
            <>
                <Helmet>
                    <title>Zanders | Dashboard</title>
                </Helmet>

                <Header />

                <PaddedContainer>
                    <Search adapter={this.adapter} basePath="/zanders/" />
                </PaddedContainer>

                <Footer />
            </>
        );
    }
}

export default withRouter(Zanders);